import type { TPositionCard } from '@/types/job';
import Link from 'next/link';
import Tags from './tags';
import styles from './card.module.scss';
import { formatMoney } from '@/utils';
import { memo } from 'react';
import { useTranslation } from 'next-i18next'

import avatarImg from '@/static/images/landing/avatar-default.jpg'
import compLogImg from '@/static/images/landing/company-log.jpg';

export default memo(function Card({
  id,
  uuid8,
  positionTitle,
  salaryFrom,
  salaryTo,
  organizationAccountProfile,
  locationStr,
  salaryUnitStr,
  salaryTimeUnitStr,
  organizationEntity,
  discussInPerson,
  
  isRemote, 
  workTimeStr, 
  requiredWorkYearStr,
  requiredEducationStr,

  shadow = true,
}: TPositionCard & { shadow: boolean }) {
  const { t } = useTranslation('common')

  const tags = { isRemote, workTimeStr, requiredWorkYearStr, requiredEducationStr }

  return (
    <li className={`${styles.module}`}>
      <a href={`/job/${uuid8}`} className={`${styles['module-a']} ${ shadow ? styles['shadow'] : '' } relative flex`}>
        <div
          className={`${styles['left-part']}  h-full text-left flex flex-col justify-between`}
        >
          <div>
            <h4 className={`${styles['req-name']}`}>
              <span className={`overflow-ellipsis-3`}>
                {positionTitle}
              </span>
            </h4>
            <div className={styles.pay}>
              {discussInPerson === 1 ? (
                <span className={`${styles['pay-salary']} w-full`}>
                  {t('LC-000585')}
                </span>
              ) : (
                <>
                  <span className={`${styles['pay-salary']} w-full`}>
                    {formatMoney(salaryFrom)}-{formatMoney(salaryTo)}
                  </span>
                  <span className={`${styles['pay-way']} w-full`}>
                    {salaryUnitStr}/{salaryTimeUnitStr}
                  </span>
                </>
              )}
            </div>
            <div className={`${styles['req-desc']}`}>
              { organizationEntity.organizationName ? (
                <div className={`${styles['org-name']} truncate`}>
                  { organizationEntity.organizationName }  
                </div>
              ) : '' }
              <div className={`${styles['org-base']} truncate`}>
                { organizationEntity.financingStageStr ? (
                  <><span className={styles['dot']}>·</span>{ organizationEntity.financingStageStr }</>
                ) : '' }
                { organizationEntity.organizationSizeStr ? (
                  <><span className={styles['dot']}>·</span>{ organizationEntity.organizationSizeStr }</>
                ) : '' }
              </div>
            </div>

            <Tags {...tags} />
          </div>
          <div className={`${styles['pub']} flex`}>
            <div
              className={`${styles['pub-icon']} bg-img`}
              style={{
                backgroundImage: `url(${organizationAccountProfile.formalPhotoUrl || avatarImg.src})`,
              }}
            ></div>
            <div className={`${styles['pub-name']}`}>
              <div className={`${styles['account-name']} truncate`}>
                {organizationAccountProfile.realName}
              </div>
              <div className={`${styles['account-title']} truncate`}> · {organizationAccountProfile.currentTitle}</div>
            </div>
          </div>
        </div>
        <div
          className={`${styles['right-part']} absolute right-0 bottom-0 top-0 w-2/4 h-full text-right flex flex-wrap justify-end content-between`}
        >
          <div
            className={styles['com-log']}
            style={{ backgroundImage: `url(${organizationEntity.organizationLogoUrl || compLogImg.src})` }}
          ></div>
          <div className="flex justify-end w-full">
            <div className={`${styles['com-location']} truncate`}>
              { locationStr }
            </div>
          </div>
        </div>
      </a>
    </li>
  );
})
